import React from "react";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const PassCard = ({
  memberType,
  passHolder,
  qrCodeUrl,
  ticketId,
  onDownload,
}) => {
  const qrUrl = `${IMAGE_BASEURL}${qrCodeUrl}`;

  return (
    <div className="pass-card position-relative">
      <div className="pass-body m-sm-4 m-3 px-3 py-3">
        <div className="pass-info">
          <p className="mb-1 value text-main"> {memberType}</p>
          <p className="value text-main mb-0">{passHolder}</p>

          <button className="btn btn-orange-md my-3" onClick={onDownload}>
            Download Ticket
          </button>

          {ticketId && <p className="ticket-id">{ticketId}</p>}

          <p className="qr-note">
            Present this QR code at the event entrance for entry
          </p>
        </div>

        <div className="qr-wrapper">
          <img src={qrUrl} alt="QR Code" />
        </div>
      </div>
    </div>
  );
};

export default PassCard;
